if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('pagination--modern') || item.target.classList?.contains('small-cards-mobile')) {
            window.dispatchEvent(new Event('scroll'));
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

// if (
//   window.location.pathname.includes("collections") ||
//   window.location.pathname.includes("search")
// ) {

//   const customTDProductListShowPriceBase = ({
//     element,
//     variant,
//     priceHasVat,
//     priceNoVat,
//     comparePriceHasVat,
//     comparePriceNoVat,
//     BSS_B2B
//   }) => {

//     if (!variant || !element) return;

//     if (!element.closest('.main-products-grid__results')) return;

//     const locale = Shopify.locale;

//     let prefix = '';

//     if (locale?.startsWith('de')) {
//       prefix = 'Ab ';
//     } else if (locale?.startsWith('en')) {
//       prefix = 'From ';
//     }

//     if (prefix && !priceNoVat.trim().startsWith(prefix)) {
//       priceNoVat = prefix + priceNoVat;
//       priceHasVat = prefix + priceHasVat;
//     }

//     element.innerHTML = priceNoVat + priceHasVat;
//   };

//   window.BSS_B2B.addAction(
//     'custom:TdProductList/showPrice',
//     customTDProductListShowPriceBase
//   );
// }


if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('quick-add__product-details')) {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
                if (item.target.classList.contains('dualPrice')) {
                   handleCartDrawerFooterMutation()
                }
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)

    async function handleCartDrawerFooterMutation() {
        if (BSS_B2B) {
            const res = await BSS_B2B.storage.productStorage.load();
            if (res) {
                if (res.notExistProductIds?.length || res.productIds?.length || res.variantIds?.size) {
                    BSS_B2B.observer.productSubject.notifyObserver('LazyProduct', 'LoadedLazyProduct', {
                    ...res
                    });
                }
            }
        }
    }

}